<template>
  <div v-if="normalizeCollapseOptions.length">
    <el-collapse v-model="collapseParent" class="collapsed without-bottom-b" accordion>
      <el-collapse-item
        v-for="(item, index) in normalizeCollapseOptions"
        :key="index"
        :title="item.title"
        :name="item.name"
      >
        <div v-if="!item.hasChildCollapse || !item.collapseChildOptions">
          <component
            :is="element.type"
            v-for="(element, i) in item.items"
            :key="i"
            :title="element.title"
            :default="element.default"
            :default1="element.default1"
            :default2="element.default2"
            :default3="element.default3"
            :valueselectdefault="element.valueselectdefault"
            :hint="element.hint"
            :min="element.min"
            :max="element.max"
            :step="element.step"
            :status="element.status"
            :options="element.options"
            :parameter="element.parameter"
            :event-click="element.eventClick"
            :default-buttons="element.defaultButtons"
            :default-icons="element.defaultIcons"
            :default-position="element.defaultPosition"
            :default-background="element.defaultBackground"
            :default-color="element.defaultIconsColor"
            :icons-size="element.iconsSize"
            :inner-component="element.innerComponent"
            :text-placeholder="element.textPlaceholder"
            :element="element"
            @changeOption="changeOption"
          />
        </div>
        <el-collapse
          v-if="item.collapseChildOptions"
          v-model="collapseChildren"
          class="collapsed child-collapse"
          accordion
        >
          <el-collapse-item
            v-for="(itemInner, ikey) in item.collapseChildOptions"
            :key="ikey"
            :title="itemInner.title"
            :name="itemInner.name"
          >
            <div v-if="!itemInner.hasChildCollapse">
              <component
                :is="element.type"
                v-for="(element, i) in itemInner.items"
                :key="i"
                :title="element.title"
                :default="element.default"
                :hint="element.hint"
                :min="element.min"
                :max="element.max"
                :step="element.step"
                :status="element.status"
                :options="element.options"
                :parameter="element.parameter"
                :event-click="element.eventClick"
                :default-buttons="element.defaultButtons"
                :default-icons="element.defaultIcons"
                :default-position="element.defaultPosition"
                :default-background="element.defaultBackground"
                :default-color="element.defaultIconsColor"
                :icons-size="element.iconsSize"
                :inner-component="element.innerComponent"
                :text-placeholder="element.textPlaceholder"
                :element="element"
                @changeOption="changeOption"
              />
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { enabledField } from "@/mixins/enabledField.mixin";

import collapseParent from "@/store/observable/option-elements-parent";
import collapseCSS from "@/store/observable/option-elements-css";
import collapseChildCSS from "@/store/observable/option-elements-child-css";

import collapseJS, { collapseJSReactive } from "@/store/observable/option-elements-js";
import collapseChildJS from "@/store/observable/option-elements-child-js";

import SelectInput from "@/widgets/options/SelectInput";
import SelectInputCustom from "@/widgets/options/SelectInputCustom";
import NumberInput from "@/widgets/options/NumberInput";
import TextInput from "@/widgets/options/TextInput";
import SeoTextInput from "@/widgets/options/SeoTextInput";
import SelectExtendedNum from "@/widgets/options/SelectExtendedNum";
import RadioExtendedNum from "@/widgets/options/RadioExtendedNum";
import RadioExtendedNumText from "@/widgets/options/RadioExtendedNumText";
import SliderInput from "@/widgets/options/SliderInput";
import RadioInput from "@/widgets/options/RadioInput";
import RadioInputAltImage from "@/widgets/options/RadioInputAltImage";
import OrderInput from "@/widgets/options/OrderInput";
import SpinControlPanel from "@/widgets/options/SpinControlPanel";
import NumberInputCustomDouble from "@/widgets/options/NumberInputCustomDouble";
import NumberInputSelect from "@/widgets/options/NumberInputSelect";
import NumberInputThreeSelect from "@/widgets/options/NumberInputThreeSelect";

export default {
  name: "OptionElements",
  components: {
    SelectInput,
    SelectInputCustom,
    NumberInput,
    TextInput,
    SelectExtendedNum,
    RadioExtendedNum,
    RadioExtendedNumText,
    SliderInput,
    RadioInput,
    RadioInputAltImage,
    OrderInput,
    SpinControlPanel,
    SeoTextInput,
    NumberInputCustomDouble,
    NumberInputSelect,
    NumberInputThreeSelect,
  },
  mixins: [enabledField],
  data() {
    return {
      collapseChildren: [],
      queryChangeParams: [],
      isZoomEnable: this.zoomEnable,
    };
  },
  computed: {
    ...mapState([
      "collapseOptions",
      "collapseOptionsCSS",
      "collapseOptionsJS",
      "settings",
      "zoomEnable",
      "clearOptions",
    ]),
    ...mapGetters([
      "getImageAssets",
      "getSpinAssets",
      "getVideoAssets",
      "getViewAssets",
      "getModelAssets",
    ]),
    collapseParent,
    collapseCSS,
    collapseChildCSS,
    collapseJS,
    collapseChildJS,
    normalizeCollapseOptions() {
      return this.collapseOptions.filter((it) => it.title !== "JS" && it.title !== "Dimensions");
    },
    optionsCSSCopy() {
      return this.settings.optionsCSS;
    },
  },
  watch: {
    clearOptions(value) {
      if (value) {
        this.collapseParent = [];
        this.collapseChildren = [];
      }
    },
    collapseParent(val) {
      if (val === "1") {
        this.$store.dispatch("enableZoom", true);
        this.collapseOptions.map((option) => {
          if (option.title === "Zoom") {
            option.items.map((item) => {
              if (item.title === "Enable") {
                item.eventClick = true;
              }
              return item;
            });
          }
          return option;
        });
      }
    },
    collapseOptions(val) {
      let tempStorage = [];

      this.queryChangeParams = [];
      val.forEach((item) => {
        if (item.hasChildCollapse === false) {
          item.items.forEach((el) => {
            if (el.eventClick === true) {
              tempStorage.push(el);
            }
          });
        } else {
          item.collapseChildOptions.forEach((el) => {
            if (el.hasChildCollapse === false) {
              el.items.forEach((innerEl) => {
                if (innerEl.eventClick === true) {
                  tempStorage.push(innerEl);
                }
              });
            }
          });
        }
      });
      let tempOptions = tempStorage[0];
      const fileUrl = this.$route.query?.file ? this.$route.query.file : null;

      if (fileUrl !== null) {
        if (this.getImageAssets.length) {
          this.collapseParent = "1";
        }

        if (this.getSpinAssets.length) {
          this.collapseParent = "2";
        }

        if (this.getVideoAssets.length) {
          this.collapseParent = "8";
        }
        if (this.getModelAssets.length) {
          this.collapseParent = "9";
        }
      }

      if (tempOptions) {
        if (tempStorage[0].parameter.indexOf("zoom") !== -1 && tempStorage.length === 1) {
          this.collapseParent = "1";
        } else {
          if (tempStorage.length > 1) {
            tempOptions = tempStorage[1];
          } else {
            tempOptions = tempStorage[0];
          }
        }

        if (tempOptions.parameter.indexOf("spin") !== -1) {
          this.collapseParent = "2";
          if (
            tempOptions.parameter.indexOf("speed") !== -1 ||
            tempOptions.parameter.indexOf("reverse") !== -1 ||
            tempOptions.parameter.indexOf("increment") !== -1
          ) {
            this.collapseChildren = "1";
          }
          if (tempOptions.parameter.indexOf("hint") !== -1) {
            this.collapseChildren = "3";
          }
          if (tempOptions.parameter.indexOf("autospin") !== -1) {
            this.collapseChildren = "2";
          }
          if (tempOptions.parameter.indexOf("zoom") !== -1) {
            this.collapseChildren = "4";
          }
          if (tempOptions.parameter.indexOf("initialize") !== -1) {
            this.collapseChildren = "5";
          }
          if (tempOptions.parameter.indexOf("control") !== -1) {
            this.collapseChildren = "6";
          }
        }

        if (tempOptions.parameter.indexOf("thumbnails") !== -1) this.collapseParent = "3";
        if (tempOptions.parameter.indexOf("slide") !== -1) this.collapseParent = "4";
        if (tempOptions.parameter.indexOf("fullscreen") !== -1) this.collapseParent = "5";
        if (tempOptions.parameter.indexOf("viewer") !== -1) this.collapseParent = "6";
        tempStorage.map((item) => {
          if (item.parameter.indexOf("layout") !== -1) this.collapseParent = "6";
        });
        if (tempOptions.parameter.indexOf("contextmenu") !== -1) this.collapseParent = "7";
        if (tempOptions.parameter.indexOf("video") !== -1) this.collapseParent = "8";
        if (tempOptions.parameter.indexOf("model") !== -1) this.collapseParent = "9";
        if (tempOptions.parameter.indexOf("lazyImage") !== -1) this.collapseParent = "10";
        if (tempOptions.parameter.indexOf("Dimensions") !== -1) this.collapseParent = "13";
      }

      tempStorage = tempStorage.map((item) => {
        return {
          parameter: item.parameter,
          separator: ":",
          value: item.default,
        };
      });
      tempStorage = tempStorage.filter(
        (item) => typeof item.value !== undefined || item.value !== "undefined"
      );
      this.queryChangeParams = tempStorage;
    },
    collapseOptionsCSS(val) {
      let tempStorage = [];
      this.queryChangeParams = [];
      val.forEach((item) => {
        if (item.hasChildCollapse === false) {
          item.items.forEach((el) => {
            if (el.eventClick === true) {
              tempStorage.push(el);
            }
          });
        } else {
          item.collapseChildOptions.forEach((el) => {
            if (el.hasChildCollapse === false) {
              el.items.forEach((innerEl) => {
                if (innerEl.eventClick === true) {
                  tempStorage.push(innerEl);
                }
              });
            }
          });
        }
      });

      let tempOptions = tempStorage[0];
      if (tempOptions && tempOptions.parameter.indexOf("inlineModeSMV") === -1) {
        if (tempOptions.type === "container-styles") {
          this.collapseCSS = "2";
        } else {
          this.collapseCSS = "1";
        }

        if (tempOptions.type.indexOf("arrows") !== -1) {
          this.collapseChildCSS = "1";
        }
        if (tempOptions.type.indexOf("full") !== -1) {
          this.collapseChildCSS = "2";
        }
        if (tempOptions.type.indexOf("thumbnails") !== -1) {
          this.collapseChildCSS = "3";
        }
        if (
          tempOptions.title.indexOf("Icons") !== -1 ||
          tempOptions.title.indexOf("position") !== -1
        ) {
          this.collapseChildCSS = "4";
        }

        if (tempOptions.type.indexOf("viewer") !== -1) this.collapseChildCSS = "5";
        if (tempOptions.type.indexOf("play") !== -1) this.collapseChildCSS = "6";
      }

      tempStorage = tempStorage.map((item) => {
        return {
          parameter: item.parameter,
          separator: ":",
          value: item.default,
        };
      });
      tempStorage = tempStorage.filter(
        (item) => typeof item.value !== undefined || item.value !== "undefined"
      );
      this.queryChangeParams = tempStorage;
    },

    collapseOptionsJS(val) {
      let tempStorage = [];
      this.queryChangeParams = [];
      val.forEach((item) => {
        if (item.hasChildCollapse === false) {
          item.items.forEach((el) => {
            if (el.eventClick === true) {
              tempStorage.push(el);
            }
          });
        } else {
          item.collapseChildOptions.forEach((el) => {
            if (el.hasChildCollapse === false) {
              el.items.forEach((innerEl) => {
                if (innerEl.eventClick === true) {
                  tempStorage.push(innerEl);
                }
              });
            }
          });
        }
      });

      let tempOptions = tempStorage[0];
      if (tempOptions) {
        if (tempOptions.type.indexOf("Script") !== -1) {
          this.collapseJS = "1";
        }
      }
    },
  },
  methods: {
    checkZoomOption(params) {
      this.$store.dispatch("enableZoom", params);
    },
    changeOption(params) {
      this.queryChangeParams = this.queryChangeParams.filter(
        (item) => item.parameter !== params.parameter
      );

      if (params.value.length) {
        this.queryChangeParams.push(params);
      }

      /*
       * Functionality video thumbnail mode enabling/disabling
       */
      //&& `${item.value}`.indexOf("//") !== -1
      const videoThumbnail = this.queryChangeParams.find(
        (item) => `${item.parameter}` === "video.thumbnail"
      );

      videoThumbnail
        ? this.$store.dispatch("video/setVideoThumbnailStatus", true)
        : this.$store.dispatch("video/setVideoThumbnailStatus", false);

      /*
       * Functionality model thumbnail mode enabling/disabling
       */
      const modelThumbnail = this.queryChangeParams.find(
        (item) => `${item.parameter}` === "model.thumbnail"
      );

      modelThumbnail
        ? this.$store.dispatch("model/setModelThumbnailStatus", true)
        : this.$store.dispatch("model/setModelThumbnailStatus", false);

      /*
       * Functionality model Skybox mode enabling/disabling
       */
      const modelSkybox = this.queryChangeParams.find(
        (item) => `${item.parameter}` === "skybox.image"
      );

      modelSkybox
        ? this.$store.dispatch("model/setModelSkyboxStatus", true)
        : this.$store.dispatch("model/setModelSkyboxStatus", false);

      /*
       * Functionality model Environment mode enabling/disabling
       */
      const modelEnvironment = this.queryChangeParams.find(
        (item) => `${item.parameter}` === "environmentImage"
      );

      modelEnvironment
        ? this.$store.dispatch("model/setModelEnvironmentStatus", true)
        : this.$store.dispatch("model/setModelEnvironmentStatus", false);

      /*
       * Functionality model Skybox Height mode enabling/disabling
       */
      const modelSkyboxHeight = this.queryChangeParams.find(
        (item) => `${item.parameter}` === "skybox.height"
      );

      modelSkyboxHeight
        ? this.$store.dispatch("model/setModelSkyboxHeightStatus", true)
        : this.$store.dispatch("model/setModelSkyboxHeightStatus", false);

      /*
       * Functionality model Camera Orbit mode enabling/disabling
       */
      const modelCameraOrbit = this.queryChangeParams.find(
        (item) => `${item.parameter}` === "camera.orbit"
      );

      modelCameraOrbit
        ? this.$store.dispatch("model/setModelCameraOrbitStatus", true)
        : this.$store.dispatch("model/setModelCameraOrbitStatus", false);

      /*
       * Functionality model Camera Target mode enabling/disabling
       */
      const modelCameraTarget = this.queryChangeParams.find(
        (item) => `${item.parameter}` === "camera.target"
      );

      modelCameraTarget
        ? this.$store.dispatch("model/setModelCameraTargetStatus", true)
        : this.$store.dispatch("model/setModelCameraTargetStatus", false);

      /*
       * Functionality model inline SMV mode enabling/disabling
       */
      const inlineModeSMV = this.queryChangeParams.find(
        (item) => `${item.parameter}` === "inlineModeSMV"
      );

      inlineModeSMV
        ? this.$store.dispatch("model/setInlineModeSMV", true)
        : this.$store.dispatch("model/setInlineModeSMV", false);

      /*
       * Functionality zoom enabling/disabling
       */
      const zoomEnabled = this.queryChangeParams.find(
        (item) => `${item.parameter}${item.separator}${item.value}` === "zoom.enable:true"
      );

      const zoomDisabled = this.queryChangeParams.find(
        (item) => `${item.parameter}${item.separator}${item.value}` === "zoom.enable:false"
      );

      if (zoomEnabled) {
        this.checkZoomOption(true);
        this.$store.dispatch("zoomEnable", true);
      } else if (zoomDisabled) {
        this.checkZoomOption(false);
      } else if (!zoomEnabled && !zoomDisabled && this.isZoomEnable === true) {
        this.checkZoomOption(true);
      }

      this.$store.dispatch("changeOption", {
        option: this.queryChangeParams
          .map((item) => `${item.parameter}${item.separator}${item.value};`)
          .join(" "),
      });

      this.$store.dispatch("changeOptionCSS", {
        optionCSS: this.optionsCSSCopy,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.without-bottom-b {
  border-bottom: none;
}
</style>
